import { render, staticRenderFns } from "./stats.vue?vue&type=template&id=7a1db38d&scoped=true&"
var script = {}
import style0 from "./stats.vue?vue&type=style&index=0&id=7a1db38d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1db38d",
  null
  
)

export default component.exports